;(function ($, window) {
    'use strict';

    var pluginName = 'locationMap';

    function Plugin(element) {
        this._name = pluginName;
        this.element = $(element);

        this.detailsElement = $(this.element).next('.avency-nwd-locations-map-details');
        this.zoom = $(this.element).data('zoom');
        this.geoJson = $(this.element).data('geo-json');
        this.lat = $(this.element).data('lat');
        this.lng = $(this.element).data('lng');
        this.showPlanmecaLoungesLayer = $(this.element).data('showPlanmecaLoungesLayer');
        this.detailsUri = $(this.element).data('details-uri');

        this.init();
        return this;
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var that = this;

            const map = L.map(that.element.get(0), {
                center: [that.lat, that.lng],
                zoom: that.zoom
            });

            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                attribution: '<a href="https://www.mapbox.com/about/maps/">© Mapbox</a>',
                minZoom: 6,
                tileSize: 512,
                zoomOffset: -1,
                maxZoom: 18,
                id: 'mapbox/streets-v11',
                accessToken: 'pk.eyJ1IjoibndkLWRlLWNzIiwiYSI6ImNrNmNjdnJ6ajA5cXozbnRmMTl1OGR4OWQifQ.MTov3IXQFBjVPz9JfAeUdQ'
            }).addTo(map);

            const greenIcon = new L.divIcon({
                html: '<i class="ai ai-location"></i>',
                shadowUrl: '/_Resources/Static/Packages/Avency.Nwd.Locations/Images/marker-shadow.png',
                iconSize: [60, 60],
                className: 'green-icon',
                iconAnchor: [30, 48],
                tooltipAnchor: [15, -30],
                shadowSize: [41, 41]
            });

            function pointToLayer(feature, latlng) {
                return L.marker(latlng, {icon: greenIcon});
            }

            function onEachFeature(feature, layer) {
                if (feature.properties && feature.properties.tooltip) {
                    const tooltip = feature.properties.tooltip;
                    layer.bindTooltip(tooltip, {direction: 'left'});
                }

                layer.on('click', function (e) {
                    if (feature.properties && feature.properties.details) {
                        var detailsIdentifier = feature.properties.details;
                        const detailElement = $(e.originalEvent.target).parents('.avency-nwd-locations-map').next('.avency-nwd-locations-map-details');

                        var map = $(e.originalEvent.target).parents('.avency-nwd-locations-map');

                        $.get({
                           url: map.data('details-uri').replace('replace', detailsIdentifier)
                        }, function (data) {
                            detailElement.html(data);
                            const images = $(detailElement).find('img');
                            $(images).each(function () {
                                window.lazyLoadObject.load(this);
                            });
                        });
                    }
                });
            }

            const locations = L.geoJSON(that.geoJson, {
                pointToLayer: pointToLayer,
                onEachFeature: onEachFeature
            }).addTo(map);

            const lounges = L.geoJSON(that.geoJson, {
                pointToLayer: pointToLayer,
                onEachFeature: onEachFeature,
                filter: function (feature) {
                    return feature.properties && feature.properties.hasPlanmecaLounge;
                }
            });

            if (that.showPlanmecaLoungesLayer && lounges.getLayers().length > 0) {
                L.control.layers({
                    "Alle Standorte": locations,
                    "Planmeca Lounges": lounges
                }).addTo(map);

                $('.leaflet-control-layers').addClass('leaflet-control-layers-expanded');
            }
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            } else {
                $.data(this, 'plugin_' + pluginName).init();
            }
        });
    };
})(jQuery, window);
